import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";

import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';

import { BasicDataSubService } from '../../../shared/basic-data-management/basic-data-subservice.class';
import { CachedDataSurveyService } from '../../../technical-modules/tasks/services/cached-data-survey.service';

import { ActeOnMTLR } from '../entities/acte-onm-tlr.entity';
import { ActeOnMEntity } from '../entities/actes-onm-entity';

@Injectable({ providedIn: 'root' })
export class ActeOnMService {
	private path: string;
	private subService!: BasicDataSubService<ActeOnMTLR>;

	constructor( //
		@Inject(HttpClient) private httpClient: HttpClient, //
		@Inject(CachedDataSurveyService) cachedDataSurveyService: CachedDataSurveyService, //
		@Optional() @SkipSelf() previousInstance?: ActeOnMService, //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
		let serverDataChanged$ = cachedDataSurveyService.getChangeNotification("ActeOm");
		this.subService = new BasicDataSubService<ActeOnMTLR>(httpClient, this.path + 'typeMaintenance?format=TLR', serverDataChanged$);
	}

	// Methode permettant le chargement de toutes les entites
	public getList = () => this.subService.getList();

	// Methodes permettant le chargement de tous les entities, selon differentes classifications et indexs
	// (NB: on procede a toutes les classifications en une fois, ce qui permet de n'iterer qu'une seule fois pour tous les resultats)
	public getMapById = () => this.subService.getMapById();
	public getById = (id: number) => this.subService.getKnownById(id, "ActeOnMTLR");

	// Methode permettant le chargement des actes onm
	public getActesOnM(classeOuvrageIds: number[], autorisedType: number): Observable<ActeOnMEntity[]> {
		let servicePath = this.path + 'typeMaintenance?format=tree&type=' + autorisedType + '&classeOuvrageIds=' + classeOuvrageIds.join(',');
		return this.httpClient.get<ActeOnMEntity[]>(servicePath);
	}

	// Methode permettant le chargement des actes onm
	public getActesSelonAcces(accesId: number): Observable<ActeOnMEntity[]> {
		let servicePath = this.path + 'typeMaintenance/actesForAssociation/' + accesId;
		return this.httpClient.get<ActeOnMEntity[]>(servicePath);
	}
}